import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const DEFAULT_META = {
    total: 0,
    page: 1,
    limit: 50,
    totalPages: 1,
};

const getOnarrivalmedicalData = createAsyncThunk(
    "api/employees/onarrivalmedical",
    async (
        { token, page = 1, limit = 50 } = {},
        { rejectWithValue }
    ) => {
        try {
            const response = await nodeinstance.get("/employees/onarrivalmedical", {
                headers: { Authorization: `Bearer ${token}` },
                params: { page, limit },
            });
            return {
                data: response?.data?.data || [],
                meta: response?.data?.meta || { ...DEFAULT_META, page, limit },
            };
        } catch (e) {
            return rejectWithValue(e?.response?.data?.message || e.message);
        }
    }
);

const OnArrivalDataSlice = createSlice({
    name: "boder",
    initialState: {
        data: null,
        meta: DEFAULT_META,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getOnarrivalmedicalData.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.meta = action.payload.meta || DEFAULT_META;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getOnarrivalmedicalData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getOnarrivalmedicalData.rejected, (state, action) => {
                state.isLoading = false;
                state.status = false;
                state.error = action.payload || action.error.message;
            });
    },
});

export { getOnarrivalmedicalData };
export default OnArrivalDataSlice.reducer;
